import Dashboard from './dashboard';
import DashboardOverview from './dashboardOverview';
import DashboardProfile from './dashboardProfile';
import DashboardSummary from './dashboardSummary';
import RecentlyViewedClients from './recentlyViewedClients';
import RecentlyViewedMaps from './recentlyViewedMaps';
import RecentlyAddedMaps from './recently_added_maps';
import CompletionList from './completionList';
import DashboardTasks from './dashboardTasks';
import DashboardUserDetails from './dashboardUserDetails';
import DashboardCalendar from './dashboardCalendar'
import DashboardCalendarTasksModal from './dashboardCalendarTasksModal';

export {
	Dashboard,
	DashboardOverview,
	DashboardProfile,
	DashboardSummary,
	RecentlyViewedClients,
	RecentlyViewedMaps,
	RecentlyAddedMaps,
	CompletionList,
	DashboardTasks,
	DashboardUserDetails,
	DashboardCalendar,
	DashboardCalendarTasksModal,
};



// WEBPACK FOOTER //
// ./src/browser/components/dashboard/index.js